import React from 'react';
import { MapPin, Clock, Compass } from 'lucide-react';
import { attractionsData } from '../data/mock';

const AttractionsSection = () => {
  return (
    <section id="attractions" className="section-spacing">
      <div className="container-coastal">
        <div className="text-center mb-xl">
          <h2 className="section-title">{attractionsData.title}</h2>
          <p className="section-subtitle" style={{ maxWidth: '700px', margin: '0 auto' }}>
            {attractionsData.subtitle}
          </p>
        </div>

        <div className="grid-3">
          {attractionsData.attractions.map((attraction) => (
            <div key={attraction.id} className="card-coastal">
              <div 
                className="image-overlay-container" 
                style={{ 
                  height: '220px',
                  marginBottom: 'var(--spacing-md)'
                }}
              >
                <img 
                  src={attraction.image} 
                  alt={attraction.name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <div className="image-overlay" />
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '0.5rem',
                marginBottom: 'var(--spacing-sm)',
                color: 'var(--color-ocean-deep)',
                fontSize: '0.875rem',
                fontWeight: '600'
              }}>
                <MapPin size={16} />
                <span>{attraction.distance}</span>
              </div>

              <h3 className="card-title mb-sm">{attraction.name}</h3>
              <p className="body-text mb-md">{attraction.description}</p>

              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem'
              }}>
                {attraction.activities.map((activity, idx) => (
                  <span
                    key={idx}
                    style={{
                      padding: '0.375rem 0.75rem',
                      background: 'var(--color-coastal-fog)',
                      color: 'var(--color-granite-gray)',
                      borderRadius: 'var(--border-radius)',
                      fontSize: '0.8125rem',
                      fontWeight: '500'
                    }}
                  >
                    {activity}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Interactive Map Link */}
        <div 
          className="card-coastal mt-xl"
          style={{ 
            padding: '0',
            overflow: 'hidden',
            maxWidth: '1000px',
            margin: 'var(--spacing-2xl) auto 0 auto',
            cursor: 'pointer'
          }}
          onClick={() => {
            const mapEl = document.querySelector('#map');
            if (mapEl) mapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}
          data-testid="explore-map-link"
        >
          <div style={{
            background: 'var(--color-coastal-fog)',
            padding: 'var(--spacing-xl)',
            textAlign: 'center'
          }}>
            <Compass size={48} color="var(--color-ocean-deep)" style={{ marginBottom: 'var(--spacing-md)' }} />
            <h3 className="card-title mb-sm">Explore the Area</h3>
            <p className="body-text mb-md" style={{ maxWidth: '600px', margin: '0 auto var(--spacing-md) auto' }}>
              Our property is perfectly situated to explore all that the Schoodic Peninsula and 
              Acadia National Park have to offer. Click to view the interactive map.
            </p>
            <div 
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '1rem 2rem',
                background: 'var(--color-ocean-deep)',
                color: 'white',
                borderRadius: 'var(--border-radius-lg)',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'background 0.3s ease'
              }}
            >
              <MapPin size={20} />
              View Interactive Map
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) translateX(0);
          }
          50% {
            transform: translateY(-20px) translateX(10px);
          }
        }
      `}</style>
    </section>
  );
};

export default AttractionsSection;
